module.exports = __webpack_public_path__ + "img/pic-paging-aiot-3.fd0d9e60.jpg";